// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CONTEST_IS_FINISHED_EXPLANATION1 = "Sout\u011b\u017e skon\u010dila";
export const CONTEST_IS_FINISHED_EXPLANATION2_link = "Proto se do n\u00ed ned\u00e1 zapojit. Pod\u00edvej se na %(link)s.\n";
export const COUNSELLING_ANSWERED = "Zodpov\u011bzen\u00e9";
export const POST_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1\u0161en\u00ed p\u0159\u00edsp\u011bvku";
export const RUNNING_CONTESTS = "prob\u00edhaj\u00edci sout\u011b\u017ee";
export const SHARE = "Sd\u00edlej";
export const TOPIC_MODERATOR = "Moder\u00e1tor";
